import React from "react";

/**
 * Einheitlicher Platzhalter für noch zu befüllende Pflichtangaben.
 * Zeigt überall — sprach­unabhängig — exakt die Formulierung
 * "NOCH BEFÜLLEN". Etwaige `label`-Props werden bewusst ignoriert,
 * damit die Formulierung auf der ganzen Seite identisch bleibt.
 */
export const TodoSlot = () => {
  return (
    <span
      className="inline-flex items-center gap-2 align-baseline rounded-md border border-dashed border-white/25 bg-white/[0.04] px-2.5 py-1 text-white/55 text-[12px] font-mono uppercase tracking-wider"
      data-testid="legal-todo-slot"
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full bg-white/30"
        aria-hidden="true"
      />
      NOCH BEFÜLLEN
    </span>
  );
};
